module.exports = __webpack_public_path__ + "static/Jillian Rivard.3b289811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Jillian Rivard.jpg
// module id = 1218
// module chunks = 6166952557895